module.exports = __webpack_public_path__ + "static/media/rotulo-stout.082b7b87.png";